import { render, staticRenderFns } from "./detalle.vue?vue&type=template&id=b3b4b80a&scoped=true&"
import script from "./detalle.vue?vue&type=script&lang=js&"
export * from "./detalle.vue?vue&type=script&lang=js&"
import style0 from "./detalle.vue?vue&type=style&index=0&id=b3b4b80a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b3b4b80a",
  null
  
)

export default component.exports